import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment as ENV } from '../../environments/environment';
import { IMidtermExamPayment, IMidtermExamPaymentCourse, IMidtermExamPaymentPayload, IMidtermExamPaymentTeacher } from '../models/MidtermExamPayment';
import { Utils } from '../core/Utils';

/**
 * Midterm examination payment service
 */
@Injectable({ providedIn: "root" })
export class MidtermExamPaymentService {
    constructor(private http: HttpClient) { }

    public get apiUrl(): string { return `${ENV.apiUrl}/midtermExamPayments` }

    /**
     * Get payments.
     * @param upn Student UPN. If not provided, returns payments for the current user.
     */
    get(upn?: string): Observable<IMidtermExamPayment[]> {
        return this.http.get<IMidtermExamPayment[]>(this.apiUrl);
    }

    getById(id: number): Observable<IMidtermExamPayment> {
        const url = `${this.apiUrl}/${id}`;
        return this.http.get<IMidtermExamPayment>(url);
    }

    add(payload: IMidtermExamPaymentPayload): Observable<{ Data: string, Url: string }> {
        return this.http.post<any>(this.apiUrl, payload);
    }

    /**
     * Get unassessed courses.
     * @param upn Student UPN. If not provided, returns courses for the current user.
     */
    getCourses(upn?: string): Observable<IMidtermExamPaymentCourse[]> {
        const url = `${this.apiUrl}/courses`;
        const params = Utils.sanitizeQueryParams({
            upn
        });

        return this.http.get<IMidtermExamPaymentCourse[]>(url, { params });
    }

    /**
     * Get course teachers.
      @param upn Student UPN. If not provided, returns teachers for the current user.
     */
    getTeachers(courseCode: string, upn?: string): Observable<IMidtermExamPaymentTeacher[]> {
        const url = `${this.apiUrl}/teachers`;
        const params = Utils.sanitizeQueryParams({
            courseCode,
            upn
        });

        return this.http.get<IMidtermExamPaymentTeacher[]>(url, { params });
    }
}
